'use client'
import React from 'react'
import { Header } from '@/components/Layouts/header'
import { Sidebar } from '@/components/Layouts/sidebar'
import { SidebarProvider } from '@/components/Layouts/sidebar/sidebar-context'
import { usePathname } from 'next/navigation'
import { type PropsWithChildren } from 'react'

const pathsNotToShowSidebar = ['/coming-soon', '/two-step-verification', '/under-maintenance']

export default function Layout({ children }: PropsWithChildren) {
  const pathname = usePathname()

  return pathsNotToShowSidebar.some(value => pathname.endsWith(value)) ? (
    children
  ) : (
    <SidebarProvider>
      <div className="flex min-h-screen">
        <Sidebar />

        <div className="bg-dark w-full">
          <Header />
          <main className="max-w-screen-3xl overflow-inherit mx-auto w-full p-2.5 md:p-6 2xl:p-10 rounded-4xl min-h-screen bg-[#EBF3F5]">{children}</main>
        </div>
      </div>
    </SidebarProvider>
  )
}
